import React from 'react';

import ToolsCardsNPM from '@rotaryintl/component-tools-cards';
import { RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import { createLink } from '@domui-sitecore/utilities/link-helpers';

import { useMobileLayout } from '@hooks/useMobileLayout';

const ToolsCards = ({ params: { ComponentId } = {}, fields: { Title, Description, ToolCards } }) => {
    const { isMobileLayout } = useMobileLayout();
 return (
  <ToolsCardsNPM
    id={ComponentId}
    title={<Text field={Title} />}
    description={<RichText field={Description} />}
    toolCards={ToolCards?.map(({ fields: { Title, Description, Link, MobileLink } }) => ({
      title: <Text field={Title} />,
      description: <RichText field={Description} />,
      link: isMobileLayout && MobileLink?.value?.href ? createLink(MobileLink):createLink(Link),
    }))}
  />
);
}

export default withSitecoreContext()(ToolsCards);
 